import { config } from '_config';
import { authHeader } from '_helpers';
import { userService } from '../_services';

export const orderService = {
    getById,
    update,
    updateAvailability,
    delete: _delete,
    getHistory,
    getNext,
    getAllNext,
    getCurrent,
    getAllCurrent,
};

function getById(id) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };

    return fetch(`${config.apiUrl}/orders/${id}`, requestOptions).then(handleResponse);
}

function update(order) {
    const requestOptions = {
        method: 'PATCH',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(order),
    };

    return fetch(`${config.apiUrl}/orders/${order.id}/`, requestOptions).then(handleResponse);
}

function updateAvailability(orderId, availability) {
    const requestOptions = {
        method: 'PATCH',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify(availability),
    };

    return fetch(`${config.apiUrl}/orders/${orderId}/availability/`, requestOptions).then(handleResponse);
}

// prefixed function name with underscore because delete is a reserved word in javascript
function _delete(id) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader(),
    };

    return fetch(`${config.apiUrl}/orders/${id}/`, requestOptions).then(handleResponse);
}

function getHistory() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };

    return fetch(`${config.apiUrl}/orders/history/`, requestOptions).then(handleResponse);
}

function getCurrent() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };

    return fetch(`${config.apiUrl}/orders/current/`, requestOptions).then(handleResponse);
}

function getAllCurrent() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };

    return fetch(`${config.apiUrl}/orders/?is_current=True&is_paid=True`, requestOptions).then(handleResponse);
}

function getNext() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };

    return fetch(`${config.apiUrl}/orders/next/`, requestOptions).then(handleResponse);
}

function getAllNext() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };

    return fetch(`${config.apiUrl}/orders/?is_next=True&is_locked=True`, requestOptions).then(handleResponse);
}

function handleResponse(response) {
    return response.text().then((text) => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                userService.logout();
                window.location.reload(true);
            }

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}



// WEBPACK FOOTER //
// ./src/_services/order.service.js